
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {nil} from '@/common';
import GenericDialog from '@/components/Views/UI/GenericDialog.vue';

@Component({
    components: {GenericDialog},
})
export default class RegisterDialog extends Mixins(GlobalAlertMixin) {
    public open = false;
    public validForm = false;
    public who = 'customer';
    public code: string = '';
    public password: string = '';
    public passwordRules = [
        (v) => !!v || 'Password is required!',
    ];

    public codeRules = [
        (v) => !!v || 'Verification code is required!',
    ];
    public registerable: any | null = null;

    @Watch('open')
    public onOpenChanged(value: boolean, oldValue: boolean) {
        if (value) {
            //this.registerable.ensureHasToken = true;
            this.registerable.save();
        }
    }

    public openWith(registerable, who = 'customer') {
        this.who = who;
        this.registerable = registerable;
        this.open = true;
    }

    public async resendCode() {
        this.registerable.needsNewToken = true;
        try {
            await this.registerable.save();
            this.showAlert(`We sent you a new code to ${this.registerable.email}`, 'success');
        } catch (e) {
            this.showAlert(e);
        }
    }
    public get registerableEmail() {
        return nil(this.registerable) ? '' : `to ${this.registerable.email}`;
    }
    public async tryVerify() {
        this.registerable.submittedToken = this.code;
        this.registerable.password = this.password;
        try {
            await this.registerable.save();
            this.showAlert(`You may now login!`, 'success');
            this.$emit('onRegister', this.registerable);
            this.open = false;
            setTimeout(() => {
                this.code = '';
                this.password = '';
            }, 2500);
        } catch (e) {
            this.showAlert(e, 'warning');
        }
    }
}
